import { useRoute } from "./lib/router";
import { ProductPage } from "./pages/ProductPage";
import { MarketingPage } from "./pages/MarketingPage";

export function App() {
  const route = useRoute();
  return route === "product" ? <ProductPage /> : <MarketingPage />;
}
